import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    minHeight: '100vh',
    padding: theme.spacing(2),
    boxSizing: 'border-box',
    backgroundColor: theme.palette.background.default,
  },
  message: {
    margin: 0,
    fontSize: 16,
    lineHeight: 1.5,
    fontWeight: 500,
    color: theme.palette.text.secondary,
  },
}));

export default useStyles;
